import React, { Component, ReactNode } from 'react';
import styled from '@emotion/styled';
import { CloseIcon } from '../../icons';
import ModalPortal from './ModalPortal';

const Overlay = styled.div<{ showModal: boolean }>`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${s => (s.showModal ? 'rgba(86, 96, 114, 0.5)' : 'rgba(86, 96, 114, 0)')};
  transition: background-color 0.45s ease-in;
  z-index: 100;
`;

const ModalBody = styled.div<{ showModal: boolean }>`
  flex: 1 1 auto;
  opacity: ${s => (s.showModal ? '1' : '0.3')};
  max-width: 815px;
  min-height: 100px;
  background: #fff;
  border: 1px solid #bdcad2;
  transition: all 0.25s ease-in;
  padding: 0 0 1rem 0;
`;

const ModalHeader = styled.div`
  height: 60px;
  background: #f2f2f2;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 2rem;

  & > span {
    color: #bdcad2;
    cursor: pointer;
    font-size: 0.8em;
  }
`;

const ModalTitle = styled.div`
  display: flex;
  justify-content: space-between;
  color: #566072;
  font-size: 1.45rem;

  span {
    margin-right: 10px;
  }

  span > svg {
    font-size: 0.9em;
  }
`;

interface Props {
  closeFn: () => void;
  modalTitle: string;
  modalIcon?: ReactNode;
  children: ReactNode;
}

interface State {
  showModal: boolean;
}

export class Modal extends Component<Props, State> {
  state = {
    showModal: false,
  };
  _isMounted = false;

  componentDidMount() {
    this._isMounted = true;
    /* wrap in timeout to stagger state change so transition
     has time to go from one state to another after render */
    setTimeout(() => {
      if (this._isMounted) {
        this.setState({ showModal: true });
      }
    }, 50);
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.setState({ showModal: false });
  }

  closeModal = () => {
    this.setState({ showModal: false });
    /* wrap in timeout to stagger state change so transition
     has time to go from one state to another after render */
    setTimeout(() => {
      this.props.closeFn();
    }, 500);
  };

  render() {
    return (
      <ModalPortal>
        <Overlay showModal={this.state.showModal}>
          <ModalBody showModal={this.state.showModal}>
            <ModalHeader>
              <ModalTitle>
                {this.props.modalIcon && <span>{this.props.modalIcon}</span>}
                <span>{this.props.modalTitle}</span>
              </ModalTitle>
              <span onClick={this.closeModal}>
                <CloseIcon />
              </span>
            </ModalHeader>
            {this.props.children}
          </ModalBody>
        </Overlay>
      </ModalPortal>
    );
  }
}

export default Modal;
